export const FLAG_GETTING_LOCATIONS_FOR_ITINERARY_SEARCH_OMISSION =
  'FLAG_GETTING_LOCATIONS_FOR_ITINERARY_SEARCH_OMISSION';
export const GET_LOCATIONS_FOR_ITINERARY_SEARCH_OMISSION =
  'GET_LOCATIONS_FOR_ITINERARY_SEARCH_OMISSION';
export const CLEAR_LOCATIONS_FOR_ITINERARY_SEARCH_OMISSION =
  'CLEAR_LOCATIONS_FOR_ITINERARY_SEARCH_OMISSION';
